import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { semanticColors , greyScaleColors } from '../../../Globals/styles'
import Tr, { types } from './tr';
import Radium from 'radium';
import { Scrollbars } from 'react-custom-scrollbars';
import { calcCompletedHours, renderOverAllocation, calcOverAllocation, sumTotalHrs } from '../../../Util/overAllocation';
import { getDates } from '../../../Util/dateTime';

class ActivityTable extends Component{
  constructor(props) {
    super(props);
    this.state = {
      showingWeekdays: false,
      activeRootId: '' //has visible children
    }
  }

  toggleRootActivity=(id) => {
    var newId = this.state.activeRootId!==id ? id : '';
    this.setState({
        activeRootId : newId
    });
  };
  toggleWeekdays = () => {
    this.setState({
      showingWeekdays: !this.state.showingWeekdays
    });
  };
  renderSpinner = () => {
    return (
      <div style={styles.loadingSpinner}>
        <div style={styles.loadingSpinnerText}>Indlæser...</div>
        <i className="fa fa-spinner fa-spin fa-2x"></i>
      </div>)
  };
  createActivityNodes = (rootIndex, collection, type, children, props, thirdIndex)=>{
    const { updatePercent, projectNumber } = this.props;
    return collection.map((item, index)=>{
      return (
        <Tr
          {...item}
          {...props}
          updatePercent={updatePercent}
          type={type}
          key={item.id}
          showingWeekdays={this.state.showingWeekdays}
          showWeekdays={this.toggleWeekdays}
          projectNumber={projectNumber}
          dh={ (refresh) => {
            this.props.deleteActivity(rootIndex, index, item.id, thirdIndex)

            if(refresh) {
              setTimeout(() => window.location.reload(),600)
            }
          }
        }
        showDelete={true}
        >
        {children}
        </Tr>
      );
    })
  };
  calcPercentComplete = arr => {
    let result = (arr.reduce((a, b) => a + b, 0)) / arr.length;
    return isNaN(result) ? 0 : result;
  };
  calcSums = () => {
    const { rootActivities } = this.props;
    var estimated = 0;
    var transferredTotal = 0;
    var weeklySum = 0;
    var mon = 0;
    var tue = 0;
    var wed = 0;
    var thu = 0;
    var fri = 0;
    var sat = 0;
    var sun = 0;
    rootActivities.forEach(a=>{
      estimated += a.estimated;
      transferredTotal += a.transferredTotal;
      weeklySum += a.weeklyTotal;
      mon += a.mon;
      tue += a.tue;
      wed += a.wed;
      thu += a.thu;
      fri += a.fri;
      sat += a.sat;
      sun += a.sun;
    });
    return {
      estimated,
      transferredTotal,
      weeklySum,
      mon, tue, wed, thu, fri, sat, sun
    };
  };
  render()  {
    const { activities, rootActivities, currDate } = this.props;
    var weekDates = getDates(currDate);
    var footerSum = this.calcSums();
    var footerPercentCompleteArr = [];
    // each rootActivity contains both Subactivity and plainActivity children
    //and goes three level deep
    //root start
    var rootActivityNodes = rootActivities.map((rootActivity, index)=>{
      var percentCompleteArr = [];
      let mappedActivities = rootActivity.activityIds.map(id=>{
        let a = activities[id];
        percentCompleteArr.push(a.percentComplete)
        return a;
      })
      // plainActivityNodes exists in same level as subactivities
      var plainActivityNodes = this.createActivityNodes(index, mappedActivities, types.second);

      //sub (contains plain activity children) - start
      var subActivityNodes = rootActivity.subActivities.map((subActivity, thirdIndex)=>{
          //third level
          var percentCompleteArrSub = [];
          let mappedActivities = subActivity.activityIds.map(id=>{
            let a = activities[id];
            percentCompleteArrSub.push(a.percentComplete);
            return a;
          })
          var activityNodes = this.createActivityNodes(index, mappedActivities, types.third, null, null, thirdIndex);

          percentCompleteArr.push(this.calcPercentComplete(percentCompleteArrSub));

        return (
          // return null if complete subActivity is not given collection, type, children, props
            subActivity.hasOwnProperty('id') ?
              (<Tr
                  {...subActivity}
                  {...{percentComplete: this.calcPercentComplete(percentCompleteArrSub)}}
                  updatePercent={this.props.updatePercent}
                  type={types.second}
                  key={subActivity.id}
                  showingWeekdays={this.state.showingWeekdays}
                  showWeekdays={this.toggleWeekdays}
                  projectNumber={this.props.projectNumber}
                  showDelete={subActivity.sumTotal===0 && subActivity.activityIds.length===0}
                  dh={ () => this.props.deleteActivity(index, thirdIndex, subActivity.id, null, true)}
                >
                {activityNodes}
              </Tr>)
              :
              null
          )
      }); //sub end

      //merge same level activityNodes and subNodes together
      var mergedNodes = plainActivityNodes.concat(subActivityNodes);

      //calcSum
      var percentComplete = this.calcPercentComplete(percentCompleteArr)
      footerPercentCompleteArr.push(percentComplete);
      // return null if complete rootActivity is not given
      return (
        rootActivity.hasOwnProperty('id') ?
          this.createActivityNodes(index, [rootActivity], types.root, mergedNodes,
            {isCollapsed: this.state.activeRootId===rootActivity.id,
              toggleCollapse: this.toggleRootActivity,
              percentComplete: percentComplete})
        :
          null
      );
    }); //root end

    //calc footer
    var footerPercentComplete = Math.floor(this.calcPercentComplete(footerPercentCompleteArr));
    var completedHrs = calcCompletedHours(footerSum.estimated,footerPercentComplete);
    var sumTotal = sumTotalHrs(footerSum.transferredTotal,footerSum.weeklySum);
    var overAllocation = calcOverAllocation(completedHrs, sumTotal);


    return (
      <div className="col-xs-12" style={styles.activitiesContainer}>
      {this.state.showingWeekdays ?
        <div>
         {rootActivities.length ?
                (<div key="one"
                    className="col-xs-1 col-xs-offset-11 btn weekBtn"
                    style={[styles.viewButton, styles.viewButtonRight]}
                    onClick={this.toggleWeekdays}>
                    {Radium.getState(this.state, 'one', ':hover') ?
                      (<div style={[styles.circleLeft, styles.circleHover]}>
                          <i className="fa fa-chevron-left">
                          </i>
                        </div>)
                      :
                      (<div style={styles.circleLeft}>
                          <i className="fa fa-chevron-left"></i>
                      </div>)
                    }
                    <div style={[styles.viewButtonText, styles.viewButtonTextRight]}>Forbrugs oversigt</div>
                  </div>)
                :
                null}
        </div> :
        <div>
          {rootActivities.length ?
                (<div
                   key="one"
                   className="col-xs-1 col-xs-offset-4 btn weekBtn"
                   style={styles.viewButton}
                   onClick={this.toggleWeekdays}>
                   {Radium.getState(this.state, 'one', ':hover') ?
                    (<div style={[styles.circleRight, styles.circleHover]}>
                        <i className="fa fa-chevron-right"></i>
                      </div>)
                    :
                    (<div style={[styles.circleRight]}>
                        <i className="fa fa-chevron-right"></i>
                      </div> )
                   }
                    <div style={styles.viewButtonText}>Uge oversigt</div>
                  </div>)
                :
                null}
        </div>
      }


{/*if*/}{this.state.showingWeekdays ?
        <div className="col-xs-12" style={styles.activitiesInnerContainer}>
          <div className="row text-right" style={styles.titles}>
              <div style={styles.headingActivityName} className="col-xs-2 col-xs-offset-1 text-left">Aktivitet</div>
              <div style={styles.headingsRight} className="col-xs-1 col-xs-offset-1">{'man ' + weekDates.mon.date.getDate()}</div>
              <div style={styles.headingsRight} className="col-xs-1">{'tir ' + weekDates.tue.date.getDate()}</div>
              <div style={styles.headingsRight} className="col-xs-1">{'ons '  + weekDates.wed.date.getDate()} </div>
              <div style={styles.headingsRight} className="col-xs-1">{'tor '  + weekDates.thu.date.getDate()} </div>
              <div style={styles.headingsRight} className="col-xs-1">{'fre '  + weekDates.fri.date.getDate()}</div>
              <div style={styles.headingsRight} className="col-xs-1">{'lør '  + weekDates.sat.date.getDate()}</div>
              <div style={styles.headingsRight} className="col-xs-1">{'søn '  + weekDates.sun.date.getDate()}</div>
          </div>
          <Scrollbars style={{ width: '100%', height: '100%'}}>
            <div className="col-xs-12" style={styles.nopaddingRows}>
              {rootActivities.length ? rootActivityNodes : this.renderSpinner()}
            </div>
          </Scrollbars>
        </div>
/*else*/ :
        <div className="col-xs-12" style={styles.activitiesInnerContainer}>
          <div className="row text-right" style={styles.titles}>
              <div style={styles.headingActivityName} className="col-xs-3 col-xs-offset-1 text-left"> Aktivitet</div>
              <div style={styles.headings} className="col-xs-1 col-xs-offset-1"> Sum Timer (Estimeret)</div>
              <div style={styles.headings} className="col-xs-1"> Overført Forbrug</div>
              <div style={styles.headings} className="col-xs-1"> Sum Forbrug </div>
              <div style={styles.headings} className="col-xs-2"> Procent udført </div>
              <div style={styles.headings} className="col-xs-1"> Udført Timer</div>
              <div style={styles.headings} className="col-xs-1"> +/-Forbrug Timer</div>
          </div>
          <Scrollbars style={{ width: '100%', height: '100%'}}>
              <div className="col-xs-12" style={styles.nopaddingRows}>
                {rootActivities.length ? rootActivityNodes : this.renderSpinner()}
              </div>
          </Scrollbars>
        </div>
    }


{/*if*/}{this.state.showingWeekdays ?
          <div className="col-xs-12" style={styles.totalRow} >
          <div className="text-right">
            <div className="col-xs-1 col-xs-offset-3">lalt</div>
            <div className="col-xs-1">{footerSum.mon}</div>
            <div className="col-xs-1">{footerSum.tue}</div>
            <div className="col-xs-1">{footerSum.wed}</div>
            <div className="col-xs-1">{footerSum.thu}</div>
            <div className="col-xs-1">{footerSum.fri}</div>
            <div className="col-xs-1">{footerSum.sat}</div>
            <div className="col-xs-1">{footerSum.sun}</div>
          </div>
        </div>
/*else*/ :
        <div className="col-xs-12" style={styles.totalRow}>
          <div className="text-right">
            <div className="col-xs-1 col-xs-offset-3">lalt</div>
            <div className="col-xs-1 col-xs-offset-1">{Math.round(footerSum.estimated*10)/10}</div>
            <div className="col-xs-1">{footerSum.transferredTotal}</div>
            <div className="col-xs-1">{sumTotal}</div>
            <div style={styles.progressbarContainer} className="col-xs-2">
              <div className="progress" style={styles.progress}>
                <div
                  aria-valuenow="60"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  className="progress-bar"
                  role="progressbar"
                  style={[styles.progressbar, {'width': footerPercentComplete + '%'}]}>
                    {footerPercentComplete}%
                </div>
              </div>
            </div>
            <div className="col-xs-1">{completedHrs}
            </div>
            <div
              className="col-xs-1"
              style={[overAllocation < 0 && styles.danger]}
            >{renderOverAllocation(overAllocation)}</div>
          </div>
        </div>
}
    </div>
    );
  }
}

var styles = {
  activitiesContainer:{
    height: '100%',
    padding: '75px 0',
    position: 'relative',
    '@media (min-width: 1200px)': {
      maxWidth: '1170px',
      left: '50%',
      marginLeft: '-585px'
    }
  },
  activitiesInnerContainer:{
    width: '100%',
    height: '100%',
    position: 'relative'
  },
  viewButton: {
    backgroundColor: semanticColors.primary,
    color: semanticColors.default,
    top: '0px',
    left: '30px',
    width: '40px',
    zIndex: '2',
    height: '100%',
    position: 'absolute',
    borderRadius : '0px',
    ':hover': {
      backgroundColor: semanticColors.primaryDark
    }
  },
  viewButtonText:{
    transform: 'rotate(270deg)',
    display: 'block',
    position: 'absolute',
    top: '50%',
    marginTop: '-10px',
    right: '-20px'
  },
  viewButtonTextRight:{
    transform: 'rotate(90deg)',
    right: '-40px'
  },
  headingActivityName:{
    lineHeight: '45px'
  },
  headings:{
    paddingLeft: '0'
  },
  headingsRight:{
    lineHeight: '45px'
  },
  viewButtonRight:{
    left: 'inherit',
    right: '0',
    lineHeight: '9px'
  },
  circleRight : {
    position: 'absolute',
    top: '50%',
    left: '7px',
    borderRadius: '100%',
    paddingLeft: '25px',
    backgroundColor: semanticColors.primary,
    borderColor: semanticColors.primary,
    width:'50px',
    marginTop: '-25px',
    height:'50px',
    zIndex: '-100',
    fontSize: '18px',
    lineHeight: '50px'
  },
  circleLeft : {
    position: 'absolute',
    top: '50%',
    right: '7px',
    paddingRight: '25px',
    borderRadius: '100%',
    backgroundColor: semanticColors.primary,
    borderColor: semanticColors.primary,
    width:'50px',
    marginTop: '-25px',
    height:'50px',
    zIndex: '-100',
    fontSize: '18px',
    lineHeight: '50px'
  },
  circleHover: {
      backgroundColor: semanticColors.primaryDark
  },
  titles: {
    position: 'absolute',
    top: '-75px',
    width: '100%',
    height: '75px',
    paddingTop: '15px',
    paddingBottom: '15px',
    fontWeight: '600',
    borderBottom: '1px solid',
    borderColor: greyScaleColors.greyLighter
  },
  totalRow : {
    height: '75px',
    fontWeight: '700',
    position: 'absolute',
    bottom: '0',
    width: '100%',
    borderTop: '1px solid',
    borderColor: greyScaleColors.greyLighter,
    lineHeight: '75px',
    backgroundColor: semanticColors.default,
    padding: '0',
    marginBottom: '1px'
  },
  nopaddingRows: {
    padding: '0',
    overflowX: 'hidden',
    overflowY: 'hidden'
  },
  progressbar: {
    minWidth: '2em',
    lineHeight: '30px',
    textAlign: 'right',
    paddingRight: '5px',
    fontWeight: '600',
    boxShadow: 'none',
    backgroundColor: semanticColors.info
  },
  progress: {
    height: '30px',
    marginTop: '25px',
    marginBottom: '0',
    boxShadow: 'none',
    backgroundColor: '#A8CEDC'
  },
  progressbarContainer: {
    paddingRight: '0'
  },
  loadingSpinner: {
    width: '100%',
    textAlign: 'center',
    marginTop: '18%',
    fontWeight: '600'
  },
  loadingSpinnerText:{
    marginBottom: '10px'
  },
  danger: {
    color: semanticColors.danger
  }
}
  ActivityTable.propTypes = {
    projectNumber: PropTypes.string.isRequired
  };
 export default Radium(ActivityTable);


// WEBPACK FOOTER //
// ./src/App/Project/WeekOverview/ActivityTable/index.jsx